import http from "./httpService";

export function getPartners() {
  return http.get("/partners");
}